export const createRoles = roleArn => {
  let roleArnSplit = roleArn.split(':');
  let accountId = roleArnSplit[4];
  return {
    adminRoleARN: `arn:aws:iam::${accountId}:role/AWSCloudFormationStackSetAdministrationRole`,
    execRoleARN: `arn:aws:iam::${accountId}:role/AWSCloudFormationStackSetExecutionRole`,
  };
};
